import * as React from 'react'

import { styled } from '../../theme'
import { VerticalMarginProps, verticalMarginsCss } from '../../theme/css'
import { Size, SizeName } from '../../theme/size'
import isReactElement from '../../utils/isReactElement'
import { Col } from './Col'

type AlignFlex =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'baseline'
  | 'space-between'

interface Props {
  className?: string
  verticalGutter?: boolean
  justifyContent?: AlignFlex
  justifyItems?: AlignFlex
  alignItems?: AlignFlex
}

class RowRaw extends React.Component<Props & VerticalMarginProps> {
  render() {
    const { className } = this.props
    return <div className={className}>{this.renderChildren()}</div>
  }

  private renderChildren() {
    const { children, verticalGutter } = this.props

    return React.Children.map(children, child => {
      if (isReactElement(child) && Boolean(child) && child.type === Col) {
        return React.cloneElement(child, { verticalGutter })
      }
      return child
    })
  }
}

export const Row = styled(RowRaw)`
  ${verticalMarginsCss};

  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: ${p => p.justifyContent};
  justify-items: ${p => p.justifyItems};
  align-items: ${p => p.alignItems};

  margin-right: -${p => p.theme.grid.gap.mobile / 2}px;
  margin-left: -${p => p.theme.grid.gap.mobile / 2}px;
  margin-bottom: ${p =>
    p.verticalGutter && `${x(p.theme.grid.gap.mobile, p.marginBottom)}px`};

  ${p => p.theme.media.desktop`
    margin-right: -${p.theme.grid.gap.desktop / 2}px;
    margin-left: -${p.theme.grid.gap.desktop / 2}px;
    margin-bottom: ${p.verticalGutter &&
      `${x(p.theme.grid.gap.desktop, p.marginBottom)}px`};
  `};
`
function x(gap: number, margin?: SizeName) {
  if (margin) {
    return Size[margin]
  }
  return -gap
}
